import React from "react";
import Footer from "../Footer/Footer";
import Publications from "./Publications";
import RelatedProjects from "../Related Projects/RelatedProjects";

function PublicationsRelatedProjects() {
  return (
    <>
        <Publications />
        <RelatedProjects />
        <Footer />
    </>
  );
}

export default PublicationsRelatedProjects;
